import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, Result, Space, Typography } from 'antd';
import { CheckCircleFilled, ShopOutlined } from '@ant-design/icons';

const { Paragraph, Text } = Typography;

function PaymentSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  let storedOrder = {};

  try {
    storedOrder = JSON.parse(sessionStorage.getItem('last_payment_order') || '{}') || {};
  } catch (error) {
    storedOrder = {};
  }

  const orderNo = params.get('out_trade_no')
    || params.get('order_no')
    || params.get('outTradeNo')
    || params.get('orderNo')
    || storedOrder.out_trade_no
    || storedOrder.order_no
    || '';
  const tradeNo = params.get('trade_no')
    || params.get('tradeNo')
    || storedOrder.trade_no
    || '';

  return (
    <div className="standalone-page">
      <div className="standalone-shell">
        <div className="page-header">
          <div className="page-header-main">
            <div className="page-title">支付完成</div>
            <div className="page-subtitle">订单支付成功后会回到这里，奖励将按照订单配置自动发放到对应角色。</div>
          </div>
        </div>

        <div className="page-note">
          <div className="page-note-text">
            <span className="page-note-strong">支付页也切入同一套独立页面风格。</span>
            不再保留原来的结果页样式，只保留订单回传和跳转逻辑。
          </div>
        </div>

        <Card className="section-card">
        <Result
          icon={<CheckCircleFilled style={{ color: '#52c41a' }} />}
          status="success"
          title="支付已完成"
          subTitle="订单支付成功，奖励会按订单配置自动发放，请返回商城或稍后到游戏内查收。"
          extra={
            <Space wrap>
              <Button type="primary" icon={<ShopOutlined />} onClick={() => navigate('/shop')}>
                返回商城
              </Button>
              <Button onClick={() => window.location.replace('/shop.html')}>
                打开静态商城
              </Button>
            </Space>
          }
        >
          <div className="selection-panel" style={{ textAlign: 'left' }}>
            <Paragraph style={{ marginBottom: 8 }}>
              <Text strong>订单号：</Text>
              <Text copyable>{orderNo || '未返回'}</Text>
            </Paragraph>
            <Paragraph style={{ marginBottom: 0 }}>
              <Text strong>支付单号：</Text>
              <Text copyable>{tradeNo || '未返回'}</Text>
            </Paragraph>
          </div>
        </Result>
        </Card>
      </div>
    </div>
  );
}

export default PaymentSuccess;
